import { getFileListHeaders } from '@nextcloud/files';
import { computed, ref } from 'vue';
/**
 * Get the registered and sorted file list headers.
 */
export function useFileListHeaders() {
    const headers = ref(getFileListHeaders());
    const sorted = computed(() => [...headers.value].sort((a, b) => a.order - b.order));
    return sorted;
}
